/**
 * <faq-filter>
 * Light-DOM wrapper around the FAQ filter pills + question list on the
 * general Services page (CU-86cbauw72). Filters by toggling the native
 * `hidden` attribute on each `[data-service]` item; "all" shows
 * everything. Only rendered when filter pills exist - individual service
 * pages render their FAQ list without this component.
 */
class FaqFilter extends HTMLElement {
  constructor () {
    super()
    this.handleClick = this.handleClick.bind(this)
  }

  connectedCallback () {
    this.buttons = [...this.querySelectorAll('[data-faq-filter]')]
    this.items = [...this.querySelectorAll('[data-service]')]
    this.addEventListener('click', this.handleClick)
  }

  disconnectedCallback () {
    this.removeEventListener('click', this.handleClick)
  }

  handleClick (event) {
    const button = event.target.closest('[data-faq-filter]')
    if (!button) { return }

    this.setActiveButton(button)
    this.applyFilter(button.dataset.faqFilter)
  }

  setActiveButton (activeButton) {
    this.buttons.forEach((button) => {
      const isActive = button === activeButton
      button.classList.toggle('is-active', isActive)
      button.setAttribute('aria-pressed', String(isActive))
    })
  }

  applyFilter (filter) {
    this.items.forEach((item) => {
      item.hidden = filter !== 'all' && item.dataset.service !== filter
    })
  }
}

customElements.define('faq-filter', FaqFilter)
